import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 mt-auto">
      <div className="max-w-site mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white text-lg font-bold mb-4">الجلب</h3>
            <p className="text-sm leading-relaxed">سوق الحلال — منصة بيع وشراء المواشي والخدمات في السعودية</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">روابط سريعة</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ads" className="hover:text-white transition">الإعلانات</Link></li>
              <li><Link to="/categories" className="hover:text-white transition">التصنيفات</Link></li>
              <li><Link to="/services" className="hover:text-white transition">الخدمات</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">تواصل معنا</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">معلومات</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition">عن الجلب</Link></li>
              <li><Link to="/terms" className="hover:text-white transition">الشروط والأحكام</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">سياسة الخصوصية</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">تواصل معنا</h4>
            <ul className="space-y-2 text-sm">
              <li>support@aljalab.com</li>
              <li>الأحد - الخميس</li>
              <li>9 صباحاً - 5 مساءً</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} الجلب — سوق الحلال. جميع الحقوق محفوظة</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
